import { Route, Routes } from 'react-router-dom';
import { Home } from './Sections/Home/Home';
import { SharedLayout } from './SharedLayout/SharedLayout';
import { Menu } from './Sections/Menu/Menu';

export const App = () => {
  return (
    <Routes>
      <Route path="/" element={<SharedLayout />}>
        <Route index element={<Home />} />

        <Route path="/menu" element={<Menu />} />

        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
};
